import designDnaExtractionEngineMarkdown from '@/assets/Artifacts/design-dna-extraction-engine.md?raw'
import muiShowcaseHtml from '@/assets/Artifacts/mui-showcase.html?raw'
import muiShowcaseWorklogMarkdown from '@/assets/Artifacts/mui-component-showcase-worklog.md?raw'

export const DESIGN_DNA_FIGMA_APP_BLOCK = {
  type: 'appConnection',
  title: 'Figma',
  description: 'Ready to receive Design DNA variables and MUI component library import.',
  iconUrl: 'https://cdn.simpleicons.org/figma/F24E1E',
  status: 'connected',
  toolkitSlug: 'figma',
  tags: ['Variables', 'Component Library'],
}

/** @param {string} artifactId @returns {object} */

export function buildDesignDnaArtifactPayload(artifactId) {
  return {
    markdown: designDnaExtractionEngineMarkdown,
    artifactId,
  }
}

/** @returns {{ html: string }} */

export function buildDesignDnaHtmlArtifactPayload() {
  return {
    html: muiShowcaseHtml,
  }
}

/** @param {string} artifactId @returns {object} */

export function buildDesignDnaShowcaseArtifactPayload(artifactId) {
  return {
    markdown: muiShowcaseWorklogMarkdown,
    artifactId,
  }
}

/**
 * Phase 1 — complete plan, full Design DNA markdown, proceed CTA.
 * @param {string} dnaArtifactId
 * @param {{ streaming?: boolean }} [opts]
 * @returns {object[]}
 */
